import { useState } from 'react';
import { BrokerageSummary } from '.';
import useBrokerManagementApi from '../../api/useBrokerManagementApi';

export const useBrokerages = () => {
  const [brokeragesSummary, setBrokeragesSummary] = useState<BrokerageSummary[]>([]);
  const [lastRetrieved, setLastRetrieved] = useState<Date>();
  const [isFetchingBrokerages, setIsFetchingBrokerages] = useState<boolean>(false);

  const { getCompanies } = useBrokerManagementApi();

  const fetchBrokerages = async () => {
    try {
      setIsFetchingBrokerages(true);
      const brokerages = await getCompanies();
      setBrokeragesSummary(brokerages.companies);
    } catch (e) {
      setBrokeragesSummary([]);
    } finally {
      setLastRetrieved(new Date());
      setIsFetchingBrokerages(false);
    }
  };

  return {
    brokeragesSummary,
    fetchBrokerages,
    lastRetrieved,
    isFetchingBrokerages,
  };
};
